export const KEY_SHORTCUTS_MAC = {
    bold: 'Cmd+B',
    italic: 'Cmd+I',
    underline: 'Cmd+U',
    strike: 'Cmd+Shift+S',
    code: 'Cmd+E',
    link: 'Cmd+Shift+U',
    bulletList: 'Cmd+Shift+8',
};
export const KEY_SHORTCUTS_WINDOWS = {
    bold: 'Ctrl+B',
    italic: 'Ctrl+I',
    underline: 'Ctrl+U',
    strike: 'Ctrl+Shift+S',
    code: 'Ctrl+E',
    link: 'Ctrl+Shift+U',
    bulletList: 'Ctrl+Shift+8',
};
export const getToolbarButtons = ({ editor, keyShortcuts, onLinkClick, onAttachClick, }) => {
    const toggleCb = (command) => () => {
        if (!editor) {
            return;
        }
        editor.chain().focus()?.[command]().run();
    };
    const formatting = [
        {
            title: `Bold (${keyShortcuts.bold})`,
            onClick: toggleCb('toggleBold'),
            disabled: !editor?.can().chain().focus().toggleBold().run(),
            isActive: editor?.isActive('bold'),
            icon: 'format_bold',
            method: 'toggleBold',
        },
        {
            title: `Italicize (${keyShortcuts.italic})`,
            onClick: toggleCb('toggleItalic'),
            disabled: !editor?.can().chain().focus().toggleItalic().run(),
            isActive: editor?.isActive('italic'),
            icon: 'format_italic',
            method: 'toggleItalic',
        },
        {
            title: `Underline (${keyShortcuts.underline})`,
            onClick: toggleCb('toggleUnderline'),
            disabled: !editor?.can().chain().focus().toggleUnderline().run(),
            isActive: editor?.isActive('underline'),
            icon: 'format_underlined',
            method: 'toggleUnderline',
        },
        {
            title: `Strikethrough (${keyShortcuts.strike})`,
            onClick: toggleCb('toggleStrike'),
            isActive: editor?.isActive('strike'),
            icon: 'format_strikethrough',
            method: 'toggleStrike',
        },
        {
            title: `Bullet list (${keyShortcuts.bulletList})`,
            onClick: toggleCb('toggleBulletList'),
            isActive: editor?.isActive('bulletList'),
            icon: 'format_list_bulleted',
            method: 'toggleBulletList',
        },
    ];
    if (onLinkClick) {
        const hasLink = editor?.isActive('link');
        if (hasLink) {
            formatting.push({
                title: 'Remove Link',
                icon: 'link_off',
                onClick: () => {
                    editor?.chain().focus().unsetLink().run();
                },
                isActive: editor?.isActive('link'),
                method: 'unsetLink',
            });
        }
        else {
            formatting.push({
                title: 'Add Link',
                onClick: () => {
                    if (editor) {
                        const { from, to } = editor.state.selection;
                        const selectedText = editor.state.doc.textBetween(from, to, ' ');
                        onLinkClick(selectedText ?? '');
                    }
                    else {
                        onLinkClick('');
                    }
                },
                isActive: editor?.isActive('link'),
                icon: 'link',
                method: 'link',
            });
        }
    }
    const other = [
        {
            title: 'Attach files',
            onClick: onAttachClick,
            isActive: editor?.isActive('filePicker'),
            icon: 'attach_file',
        },
    ];
    return {
        formatting,
        other,
    };
};
